'use strict'

/*
* V2.0.0
* changed topPosition = $el.position().top
* to
* topPosition = $el.offset().top
*/

export default function (elementsSelector) {
  let currentTallest = 0
  let currentRowStart = 0
  let rowDivs = []
  let $el
  let topPosition = 0

  if ($(elementsSelector).length) {
    $(elementsSelector).each(function () {
      let currentDiv

      $el = $(this)
      $($el).height('auto')
      topPosition = Math.round($el.offset().top)

      if (currentRowStart != topPosition) {
        for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
          rowDivs[currentDiv].height(currentTallest)
        }
        rowDivs.length = 0 // empty the array
        currentRowStart = topPosition
        currentTallest = $el.height()
        rowDivs.push($el)
      } else {
        rowDivs.push($el)
        currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest)
      }

      // If the element is on a row on it's own then set the height to auto otherwise set them all the same.
      if (rowDivs.length > 1) {
        for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
          if (currentTallest < 10) {
            currentTallest = 10
          }
          rowDivs[currentDiv].height(currentTallest)
        }
      } else {
        for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
          rowDivs[currentDiv].height('auto')
        }
      }
    })
  }
}
